import { Box, Chip, ChipProps, SxProps } from '@mui/material';
import { FC } from 'react';
import { sxs } from '@utils/mui/sx';

interface TagsProps {
    hitId: string;
    sx?: SxProps;
    tags: (string | JSX.Element)[];
    variant?: ChipProps['variant'];
}

const Tags: FC<TagsProps> = ({ hitId, sx = {}, tags, variant }) => {
    if (tags.length === 0) return null;

    return (
        <Box width="100%">
            {tags.map((tag) => (
                <Chip
                    key={'string' === typeof tag ? `${tag}-${hitId}` : `element-tag-${hitId}`}
                    data-test-id="tag"
                    label={tag}
                    sx={sxs([{ mb: 1, mr: 1 }, sx])}
                    variant={variant}
                />
            ))}
        </Box>
    );
};

export default Tags;
